import React from "react";
// import Table_out from "./Table_out";
import New_table from "./../Outstanding_report/New_table"

function Outstanding() {
  return <New_table></New_table>;
}

export default Outstanding;
